var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as moment from 'moment';
import { BaseEntity, MemoizeGetters, Transform, toDate } from './base';
let MessageModel = class MessageModel extends BaseEntity {
    get relativeTime() {
        let momentDate = moment(this.createdAt);
        return momentDate.fromNow();
    }
};
__decorate([
    Transform(toDate),
    __metadata("design:type", Date)
], MessageModel.prototype, "createdAt", void 0);
MessageModel = __decorate([
    MemoizeGetters
], MessageModel);
export { MessageModel };
//# sourceMappingURL=message.js.map


// WEBPACK FOOTER //
// ./src/models/message.ts.pre-build-optimizer.js